<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Attributs"
                createIconText="Ajouter un attribut"
                importDatasourceName="attributedefinitions"
                (created)="onAttributeCreated()"
                (exported)="onAttributesExported()"
                (imported)="onAttributesImported()"
                (helped)="onAttributesHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-attributes-list
            #itemsList
            (itemSelected)="onAttributeSelected($event)"
            (itemDisplayed)="onAttributeDisplayed($event)"
            (itemEdited)="onAttributeEdited($event)"
            (itemDeleted)="onAttributeDeleted($event)"
            (itemDuplicated)="onAttributeDuplicated($event)"
            (itemsSorted)="onAttributesSorted($event)">
            >
        </app-attributes-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onAttributeDisplayed(context?.formContext.item)"
                    (edited)="onAttributeEdited(context?.formContext.item)"
                    (helped)="onAttributesHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-attribute-detail
                [context]="context"
                (attributeUpdated)="onAttributeUpdated($event)"
                (attributeValuesUpdated)="onAttributeValuesUpdated($event)"
                (needAttributeValuesRefreshed)="onNeedAttributeValuesRefreshed($event)"
                (canceled)="onBackToList()"></app-attribute-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
